module.exports = __webpack_public_path__ + "img/banner.dedae9d5.png";